var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.097,
    height: 29.91,
    viewBox: "0 0 34.097 29.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 34.097,
    height: 29.91,
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_374",
    "data-name": "Groupe 374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_350",
    "data-name": "Groupe 350",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2842",
    "data-name": "Trac\\xE9 2842",
    d: "M0,11.185c.12-.672.192-1.357.368-2.015A11.681,11.681,0,0,1,5.82,2.005,13.745,13.745,0,0,1,21.563,3.021c.338.269.633.59.967.862a1.157,1.157,0,0,0,.512.247c4.449.731,7.914,2.918,9.9,7.035a10.811,10.811,0,0,1-.8,11.063.693.693,0,0,0-.1.665c.612,1.871,1.2,3.75,1.8,5.627a.979.979,0,0,1-.679,1.377,1.422,1.422,0,0,1-.819-.144Q29.6,28.4,26.889,26.988a.76.76,0,0,0-.68-.027,13.621,13.621,0,0,1-13.724-2.03,4.528,4.528,0,0,1-.718-.641,1.754,1.754,0,0,0-1.052-.536c-.989-.229-1.964-.518-2.937-.81a.675.675,0,0,0-.558.026c-1.832.938-3.664,1.876-5.507,2.794a1.409,1.409,0,0,1-.789.149A.975.975,0,0,1,.21,24.555q.9-2.848,1.818-5.69a.585.585,0,0,0-.078-.576A11.043,11.043,0,0,1,.059,13.1,1.929,1.929,0,0,0,0,12.847V11.185M31.226,26.956c-.041-.15-.063-.244-.093-.336-.388-1.223-.757-2.453-1.173-3.666a1.426,1.426,0,0,1,.244-1.448,9.162,9.162,0,0,0-.087-11.181,10.858,10.858,0,0,0-8.088-4.278A11.1,11.1,0,0,0,13,9.258a8.989,8.989,0,0,0-2.746,8.23,9.481,9.481,0,0,0,4.891,6.85,11.575,11.575,0,0,0,10.783.577,1.442,1.442,0,0,1,1.357.032c.885.479,1.791.92,2.689,1.376.4.2.8.4,1.255.632m-21.774-5.5.05-.07c-.049-.1-.1-.2-.148-.3A10.878,10.878,0,0,1,9.4,10.813a12.512,12.512,0,0,1,8.97-6.544c.394-.085.795-.135,1.256-.213-.192-.129-.324-.225-.463-.311A11.463,11.463,0,0,0,14,2.057,11.319,11.319,0,0,0,5.609,4.6,9.3,9.3,0,0,0,2,12.257,8.93,8.93,0,0,0,3.9,17.58a1.3,1.3,0,0,1,.223,1.3c-.4,1.218-.787,2.442-1.177,3.665-.039.122-.066.248-.109.415.185-.09.324-.156.461-.225,1.194-.607,2.389-1.21,3.578-1.825a1.222,1.222,0,0,1,1.143-.03c.47.213.957.387,1.437.577",
    transform: "translate(0 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2843",
    "data-name": "Trac\\xE9 2843",
    d: "M37.2,35.8a1,1,0,1,1,.984-1,1.009,1.009,0,0,1-.984,1",
    transform: "translate(-20.161 -18.835)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2844",
    "data-name": "Trac\\xE9 2844",
    d: "M56.2,34.806a1,1,0,1,1-.991-.994,1.009,1.009,0,0,1,.991.994",
    transform: "translate(-30.199 -18.835)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2845",
    "data-name": "Trac\\xE9 2845",
    d: "M47.195,34.812a1,1,0,1,1-.983-1,1.009,1.009,0,0,1,.983,1",
    transform: "translate(-25.18 -18.835)",
    fill: "#015c7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.5df02c8f915e81f5b85ec116f651e394.svg";
export { ForwardRef as ReactComponent };